import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/EventStyling.css";

export default function EventStyling() {
  const [eventsHeader, setEventHeader] = useState([]);
  const [eventMontage, setEventMontage] = useState([]);
  const [awardData, setAwardData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchImages = async () => {
      setLoading(true);

      try {
        const [eventRes, awardRes] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_URL}/api/images/events`),
          fetch(`${process.env.REACT_APP_API_URL}/api/images/main`),
        ]);

        if (!eventRes.ok) {
          throw new Error(eventRes.message || "Failed to fetch event images");
        }
        if (!awardRes.ok) {
          throw new Error(awardRes.message || "Failed to fetch award image");
        }

        const eventData = await eventRes.json();
        const awardData = await awardRes.json();

        setEventHeader(eventData.data.header);
        setEventMontage(eventData.data.montage);
        setAwardData(awardData.data.award);
      } catch (err) {
        setError(err.message || "Failed to fetch images");
      } finally {
        setLoading(false);
      }
    };
    fetchImages();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Unable to load images.</div>;
  }

  if (!eventsHeader.length) return <div>No data</div>;

  return (
    <div className="events">
      {/* Events Header */}
      <section className="events__intro--container">
        <div className="events__intro--header">
          <img
            src={eventsHeader[0]?.src}
            alt={eventsHeader[0]?.alt}
            className="events__intro--image"
          />
          <div className="events__intro--text">
            <h1>Event Styling</h1>
            <p>
              Luxury Styling for Weddings, Memorials, Melbourne Cup, Workshops &
              Private Events
            </p>
          </div>
          <div className="events_award--container-right">
            <img
              src={awardData[2]?.src}
              alt={awardData[2]?.alt}
              className="events__intro--image"
            />
          </div>
        </div>

        <div className="events__intro--content">
          <h2>Event Styling</h2>
          <p>
            Luxury event styling tailored to suit any occasion. Whether you're
            planning a wedding, celebration of life, staff party, workshop, or
            private gathering, we bring elegance and creativity to every
            setting.
          </p>
          <p>
            Our styling services are available at your chosen venue and include
            beautifully curated place settings, detailed table décor, and our
            luxury picnic-style setups. From intimate affairs to grand
            celebrations, we design with care, style with purpose, and ensure
            every detail reflects your unique vision.
          </p>
          <p>
            Each event is unique and individually quoted to suit your specific
            requirements, with styling packages tailored to suit the size,
            style, and scope of your event.
          </p>
        </div>
      </section>

      {/* Event Options */}
      <section className="events__container">
        <div className="events__options--container">
          <div className="events__options--image-container">
            {/* Image Placeholder */}
            <img
              className="events__options--image"
              src={eventMontage[0]?.src}
              alt={eventMontage[0]?.alt}
            />
          </div>
          {/* Events Content */}
          <div className="events__options--details">
            <div className="events__options--header">
              <h2>Starting from $400</h2>
            </div>
            <h2>
              Let us bring your vision to life and transform your event into
              something truly special.
            </h2>
            <h3>
              <strong>Signature Setup Options:</strong>
            </h3>
            <div className="events__options--inclusions">
              <ul>
                <li>1. A relaxed low-lying picnic table arrangement.</li>
                <li>
                  2. A gathered-style setting featuring picnic rugs and small
                  tables for a more casual, social atmosphere.
                </li>
              </ul>
            </div>
            <h3>
              <strong>Enhance Your Event</strong>
            </h3>
            <div className="events__options--inclusions">
              <ul>
                <li>
                  Individual place settings for your existing table setup.
                </li>
                <li>
                  Dining-height tables, perfect for grazing or dessert displays.
                </li>
                <li>
                  A stylish drinks station complete with drink dispensers and
                  ice-filled buckets.
                </li>
                <li> </li>
              </ul>
            </div>

            <div className="events__options--options">
              <Link
                to="/additions"
                className="events__options--options-btn my-btn"
              >
                Additions/Enhancements
              </Link>
            </div>
          </div>
        </div>

        {/* Event Images Row 1 */}
        <section className="events__options--montage-large">
          <div className="events__options--montage-container">
            <img
              src={eventMontage[1]?.src}
              alt={eventMontage[1]?.alt}
              className="events__options--montage"
            ></img>
            <img
              src={eventMontage[2]?.src}
              alt={eventMontage[2]?.alt}
              className="events__options--montage"
            ></img>
            <img
              src={eventMontage[3]?.src}
              alt={eventMontage[3]?.alt}
              className="events__options--montage"
            ></img>
            <img
              src={eventMontage[4]?.src}
              alt={eventMontage[4]?.alt}
              className="events__options--montage"
            ></img>
          </div>

          {/* Event Images Row 2 */}
          <div className="events__options--montage-container">
            <img
              src={eventMontage[5]?.src}
              alt={eventMontage[5]?.alt}
              className="events__options--montage"
            ></img>
            <img
              src={eventMontage[6]?.src}
              alt={eventMontage[6]?.alt}
              className="events__options--montage"
            ></img>
            <img
              src={eventMontage[7]?.src}
              alt={eventMontage[7]?.alt}
              className="events__options--montage"
            ></img>
            <img
              src={eventMontage[8]?.src}
              alt={eventMontage[8]?.alt}
              className="events__options--montage"
            ></img>
          </div>
          {/* Group Images Row 3 */}
          <div className="events__options--montage-container">
            <img
              src={eventMontage[9]?.src}
              alt={eventMontage[9]?.alt}
              className="events__options--montage"
            ></img>
            <img
              src={eventMontage[10]?.src}
              alt={eventMontage[10]?.alt}
              className="events__options--montage"
            ></img>
            <img
              src={eventMontage[11]?.src}
              alt={eventMontage[11]?.alt}
              className="events__options--montage"
            ></img>
            <img
              src={eventMontage[12]?.src}
              alt={eventMontage[12]?.alt}
              className="events__options--montage"
            ></img>
          </div>
          {/* Group Images Row 4 */}
          <div className="events__options--montage-container">
            <img
              src={eventMontage[13]?.src}
              alt={eventMontage[13]?.alt}
              className="events__options--montage"
            ></img>
            <img
              src={eventMontage[14]?.src}
              alt={eventMontage[14]?.alt}
              className="events__options--montage"
            ></img>
            <img
              src={eventMontage[15]?.src}
              alt={eventMontage[15]?.alt}
              className="events__options--montage"
            ></img>
            <img
              src={eventMontage[16]?.src}
              alt={eventMontage[16]?.alt}
              className="events__options--montage"
            ></img>
          </div>
        </section>
        {/* Mapped images for smaller screens */}
        <section className="events__montage--grid">
          {eventMontage
            .slice(1, 16)
            .filter((img) => img.src)
            .map((image, index) => (
              <img
                key={index}
                src={image.src}
                alt={image.alt || "Events"}
                className="events__montage--grid-image"
              />
            ))}
        </section>
      </section>
    </div>
  );
}
